import { Col, Row } from "reactstrap";
const TotalSales = ({ todaySales }) => {
  return (
    <>
      <div className="mb-4">
        <div className="d-flex flex-column mb-4">
          <h3 className="fs-24 fw-bold text-dark mb-1">Dashboard Overview</h3>
          <p className="fs-14 text-muted">A quick summary of your business performance</p>
        </div>
        <Row>
          {todaySales?.map((item, index) => {
            return (
              <Col lg={3} md={6} key={index} className="mb-4">
                <div className="dashboard-stat-card">
                  <div className={`stat-icon-box ${item.colorClass}`}>
                    <item.icon size={24} />
                  </div>
                  <div className="stat-content">
                    <p className="stat-title">{item.subTitle}</p>
                    <h4 className="stat-value">{item.title ?? 0}</h4>
                    <p className="stat-description">{item.percent}</p>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </>
  );
};
export default TotalSales;
